import type { IEditorConfig } from '@deity-io/di-data-flows-editor';

export const virtualSettings = (name: string, editorConfig: IEditorConfig, input = true) => {
  const ports = {};
  const portName = input ? 'input' : 'next';
  ports[portName] = {
    type: input ? 'input' : 'output',
    position: {
      x: input ? 0 : 1,
      y: 0.5
    },
    color: '#DADFE4',
    borderColor: '#C1C8D0',
    dimensions: {
      width: '16',
      height: '16'
    }
  };

  return {
    settings: {
      type: '@virtual',
      icon: '',
      displayName: name,
      description: name,
      dimensions: {
        width: 100,
        height: 100
      },
      editor: editorConfig
    },
    ports
  };
};
